import http from '../../../utils/tools/http';

import {
  TOPIC_GET_PHONE_CODE_IS_TRUE_BEGIN,
  TOPIC_GET_PHONE_CODE_IS_TRUE_SUCCESS,
  TOPIC_GET_PHONE_CODE_IS_TRUE_FAILURE,
  TOPIC_GET_PHONE_CODE_IS_TRUE_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPhoneCodeIsTrue(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: TOPIC_GET_PHONE_CODE_IS_TRUE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
        const doRequest = http.get({ url: "/datastore/Student/getPhoneCodeIsTrue", params: args });
      doRequest.then(
        (res) => {
          dispatch({
            type: TOPIC_GET_PHONE_CODE_IS_TRUE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: TOPIC_GET_PHONE_CODE_IS_TRUE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPhoneCodeIsTrueError() {
  return {
    type: TOPIC_GET_PHONE_CODE_IS_TRUE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TOPIC_GET_PHONE_CODE_IS_TRUE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPhoneCodeIsTruePending: true,
        getPhoneCodeIsTrueError: null,
      };

    case TOPIC_GET_PHONE_CODE_IS_TRUE_SUCCESS:
      // The request is success
      return {
        ...state,
        getPhoneCodeIsTruePending: false,
        getPhoneCodeIsTrueError: null,
      };

    case TOPIC_GET_PHONE_CODE_IS_TRUE_FAILURE:
      // The request is failed
      return {
        ...state,
        getPhoneCodeIsTruePending: false,
        getPhoneCodeIsTrueError: action.data.error,
      };

    case TOPIC_GET_PHONE_CODE_IS_TRUE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPhoneCodeIsTrueError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/topic/redux/getPhoneCodeIsTrue.js